import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { HttpService } from '../../services/http.service';
import { StorageService } from '../../services/storage.service';
import { KeycloakService } from 'keycloak-angular';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const storage: StorageService = inject(StorageService);

  if (authService.isAuthenticated() && storage.getItem('userData')) {
    if (state.url === '/') {
      router.navigate(['home']).then();
      return false;
    }
    return true;
  }

  const keycloak: KeycloakService = inject(KeycloakService);
  if (await keycloak.isLoggedIn()) {
    const httpService: HttpService = inject(HttpService);

    try {
      const token = await keycloak.getToken();
      storage.setItem('authToken', token);
      const userData = await firstValueFrom(httpService.getUserProfileFromKeycloak());
      return authService.checkLoginStatus(userData, 'login', false);
    } catch (error) {
      console.error('Unable to initialize the Keycloak user profile', error);
    }
  }

  router.navigate(['landing-page']).then();
  return false;
};
